import BaseEntityModelFilter from "./../../general/BaseEntityModelFilter";
import store from "./../../../store";

export default class InstallmentScheduleTimesFilter extends BaseEntityModelFilter {
  constructor() {
    super();
    this.setInitialValue();
  }
  setInitialValue() {
    this.setFilterInitialValue();
    this.activationTypeTokens =
      store.getters.generalSetting.installmentScheduleTimes
        .activationTypeTokens ?? [];
    this.debtScheduleTimeToken = "";
    this.installmentBatchTypeToken = "";
    this.userToken = "";
    this.debtToken = "";
  }
  fillData(data) {
    if (data) {
      this.fillFilterData(data);
    } else {
      this.setInitialValue();
    }
  }
}
